import _ from 'lodash';
import smh from '@/renderer/scripts/smh';
type Hander = {
  hasSurveyInfo: () => Promise<boolean>;
  hasGuidance: () => Promise<boolean>;
};
const userGuideInfoHandler = (): Hander => {
  const mehthods = {
    async hasSurveyInfo() {
      return new Promise<boolean>(async resolve => {
        try {
          const { data = [] } = await smh.userAPI.getSurvey();
          if (data.length !== 0) {
            // 说明已经留资
            resolve(true);
          }
          resolve(false);
        } catch (e) {
          resolve(true);
        }
      });
    },
    hasGuidance() {
      return new Promise<boolean>(async resolve => {
        // 做了老用户留的兼容，不给参数，表示已经有留咨询
        try {
          const { data } = await smh.userAPI.queryNoviceGuidance();
          if (_.isEmpty(data.data)) {
            // 说明没有新手引导
            resolve(false);
          }
          resolve(true);
        } catch (e) {
          resolve(false);
        }
      });
    },
  };
  return {
    ...mehthods,
  };
};
export default userGuideInfoHandler;
